import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  name: string,
 *  month: number,
 *  day: number,
 *  thresholdDays: number }} KeyDate
 */

const api = new Api("api/keydates");

/**
 * @param {number} id
 * @returns {Promise<AxiosResponse<KeyDate>>}
 */
export const getById = (id) => api.get(id);

/**
 * @param {string} name
 * @returns {Promise<AxiosResponse<KeyDate>>}
 */
export const getByName = (name) => api.get("", { name });

export const update = (id, payload) => api.putId(id, payload);
